import React from "react";
import DeveloperDashboard from "./DeveloperDashboard";

function App() {
  return <DeveloperDashboard />;
}

export default App;